import { render, staticRenderFns } from "./addSonDrawer.vue?vue&type=template&id=3298bde5&scoped=true&"
import script from "./addSonDrawer.vue?vue&type=script&lang=js&"
export * from "./addSonDrawer.vue?vue&type=script&lang=js&"
import style0 from "./addSonDrawer.vue?vue&type=style&index=0&id=3298bde5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3298bde5",
  null
  
)

export default component.exports